import { loadScript } from '@cuemath/leap';
import { APPLE_CLIENT_ID, APPLE_JS_SDK_URL } from '@~/constants/app-config';
import { EVENT_TYPE } from '@~/constants/logger';
import analytics from '@~/modules/analytics';

export const initializeAppleSDK = async () => {
  try {
    await loadScript(APPLE_JS_SDK_URL, 'appleid-sdk');
    if (window.AppleID) {
      window.AppleID.auth.init({
        clientId: APPLE_CLIENT_ID,
        scope: 'name email',
        redirectURI: `${window.location.origin}/auth/apple/callback`,
        usePopup: true,
      });
    }
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';

    analytics.trackEvent(EVENT_TYPE.APPLE_AUTH_SDK_LOAD_FAILED, {
      error: errorMessage,
    });
  }
};
